import React from 'react';

import { Typography } from '@mui/material';
import { AlineAvatar } from 'src/components';
import type { DisplayWorkflowPermission } from 'src/components/workflow/workflow-helpers';
import { getWorkflowPermissionDisplayDetails } from 'src/components/workflow/workflow-helpers';
import { makeStyles } from 'tss-react/mui';

const useCollaboratorAvatarStyles = makeStyles()(theme => ({
  avatarTextContainer: {
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  collaboratorSecondaryText: {
    fontSize: 12,
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(1.5),
  },
}));

interface CollaboratorAvatarAndTextProps {
  permission: DisplayWorkflowPermission;
}

export function CollaboratorAvatarAndText({ permission }: CollaboratorAvatarAndTextProps) {
  const { classes } = useCollaboratorAvatarStyles();
  const { avatarColor, avatarInfo, primaryText, secondaryText } =
    getWorkflowPermissionDisplayDetails(permission);

  return (
    <div className={classes.wrapper}>
      <AlineAvatar avatarInfo={avatarInfo} styles={{ backgroundColor: avatarColor, size: 'md' }} />
      <div className={classes.avatarTextContainer}>
        <Typography noWrap variant="subtitle2">
          {primaryText}
        </Typography>
        {secondaryText && (
          <Typography
            noWrap
            className={classes.collaboratorSecondaryText}
            color="textSecondary"
          >{`(${secondaryText})`}</Typography>
        )}
      </div>
    </div>
  );
}
